[
  {
    "code": "CU-15",
    "name": "Artemisa"
  },
  {
    "code": "CU-09",
    "name": "Camagüey"
  },
  {
    "code": "CU-08",
    "name": "Ciego de Ávila"
  },
  {
    "code": "CU-06",
    "name": "Cienfuegos"
  },
  {
    "code": "CU-12",
    "name": "Granma"
  },
  {
    "code": "CU-14",
    "name": "Guantánamo"
  },
  {
    "code": "CU-11",
    "name": "Holguín"
  },
  {
    "code": "CU-99",
    "name": "Isla de la Juventud"
  },
  {
    "code": "CU-03",
    "name": "La Habana"
  },
  {
    "code": "CU-10",
    "name": "Las Tunas"
  },
  {
    "code": "CU-04",
    "name": "Matanzas"
  },
  {
    "code": "CU-16",
    "name": "Mayabeque"
  },
  {
    "code": "CU-01",
    "name": "Pinar del Río"
  },
  {
    "code": "CU-07",
    "name": "Sancti Spíritus"
  },
  {
    "code": "CU-13",
    "name": "Santiago de Cuba"
  },
  {
    "code": "CU-05",
    "name": "Villa Clara"
  }
]